import { Injectable } from "@angular/core";
import { FiltrosService } from "../../../../../../layout/investigaciones/ver-respuestas/filtros.service";
import { RespuestaUsuario } from "@DTOS";
import { FiltroRespuesta } from "../../../../../../layout/investigaciones/ver-respuestas/Filtro.respuestas";
import { RespuestasHelper } from "../../RespuestasHelper";

@Injectable()
export class PasoFiltrado {
    private respuestas: RespuestaUsuario[] = [];
    private filtros: FiltroRespuesta[] = [];

    constructor(private filtrosService: FiltrosService, private respuestasHelper: RespuestasHelper) {}

    public filtrar(respuestas: RespuestaUsuario[]): RespuestaUsuario[] {
        this.cargarCacheLocal(respuestas);

        if (this.filtros.length === 0) {
            this.limpiarCacheLocal();
            return respuestas;
        }
        const respuestasFiltradas = this.obtenerRespuestasFiltradas();
        this.limpiarCacheLocal();
        return respuestasFiltradas;
    }

    private cargarCacheLocal(respuestas: RespuestaUsuario[]) {
        this.respuestas = respuestas;
        this.filtros = this.filtrosService.obtenerFiltrosSinComparativos();
    }

    private limpiarCacheLocal() {
        this.respuestas = [];
        this.filtros = [];
    }

    private obtenerRespuestasFiltradas(): RespuestaUsuario[] {
        const indices = this.respuestasHelper.obtenerIndices(this.respuestas, this.filtros);
        return indices.map(indice => this.respuestas[indice]);
    }
}
